"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isVideo = exports.isImage = void 0;
const isImage = (url) => {
    const imageExtensions = ["png", "jpg", "jpeg", "webp", "gif"];
    const extension = url.split(".").pop()?.toLowerCase();
    return extension ? imageExtensions.includes(extension) : false;
};
exports.isImage = isImage;
const isVideo = (url) => {
    const videoExtensions = ["mp4", "webm", "ogg", "mov", "avi", "wmv", "flv", "mkv"];
    const extension = url.split(".").pop()?.toLowerCase();
    return extension ? videoExtensions.includes(extension) : false;
};
exports.isVideo = isVideo;
